import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-8 col-xxl-9 offset-lg-4 offset-xxl-3 small mb-1" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "contact-companyId",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, "IČO", -1)
const _hoisted_5 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  for: "contact-email",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode(" E-mail pro fakturaci "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_10 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_11 = { class: "invalid-feedback" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "contact-name",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Název "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_15 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_16 = { class: "invalid-feedback" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "contact-street",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, "Ulice", -1)
const _hoisted_20 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_21 = { class: "invalid-feedback" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "contact-city",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, "Město", -1)
const _hoisted_25 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_26 = { class: "invalid-feedback" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_28 = { class: "row" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  for: "contact-zip",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, "PSČ", -1)
const _hoisted_30 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_31 = { class: "invalid-feedback" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_33 = { class: "row" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "contact-country",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, [
  /*#__PURE__*/_createTextVNode(" Země "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger fw-bold" }, "*")
], -1)
const _hoisted_35 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "Česká republika" }, "Česká republika", -1)
const _hoisted_37 = { class: "invalid-feedback" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", {
  for: "contact-vatId",
  class: "col-lg-4 col-xxl-3 col-form-label"
}, "DIČ", -1)
const _hoisted_41 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_42 = { class: "invalid-feedback" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_44 = { class: "row" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-xxl-3 col-form-label d-none d-lg-block" }, "Plátce DPH", -1)
const _hoisted_46 = { class: "col-lg-8 col-xxl-9 d-flex align-items-center mt-3 mt-lg-0" }
const _hoisted_47 = { class: "form-check" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "contact-vatPayer"
}, " Subjekt je plátcem DPH ", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "border-bottom pt-4 mb-4 d-none d-lg-block" }, null, -1)
const _hoisted_50 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_SubmitButton = _resolveComponent("SubmitButton")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.onSubmit,
    "validation-schema": _ctx.schema,
    "initial-values": _ctx.contact,
    class: "p-4 p-lg-5 bg-white rounded-3 border"
  }, {
    default: _withCtx(({ errors }) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            href: `https://wwwinfo.mfcr.cz/cgi-bin/ares/ares_es.cgi?jazyk=cz&ico=${_ctx.companyId}&xml=1`,
            class: "link-secondary opacity-50",
            target: "_blank"
          }, " Ověřit na Aresu " + _toDisplayString(_ctx.companyId && ' - IČO: ' + _ctx.companyId), 9, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            class: _normalizeClass(["input-group", { 'is-invalid' : errors.companyId }])
          }, [
            _createVNode(_component_Field, {
              modelValue: _ctx.companyId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.companyId) = $event)),
              name: "companyId",
              type: "text",
              class: _normalizeClass(["form-control", { 'is-invalid' : errors.companyId }]),
              id: "contact-companyId"
            }, null, 8, ["modelValue", "class"]),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFetchAres && _ctx.handleFetchAres(...args))),
              class: "btn btn-outline-secondary text-decoration-line-through",
              type: "button",
              disabled: "!btnAresEnabled"
            }, "Vyplnit podle IČO ")
          ], 2),
          _createElementVNode("div", _hoisted_6, _toDisplayString(errors.companyId), 1)
        ])
      ]),
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Field, {
            name: "email",
            type: "email",
            class: _normalizeClass(["form-control", { 'is-invalid' : errors.email }]),
            id: "contact-email"
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(errors.email), 1)
        ])
      ]),
      _hoisted_12,
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_Field, {
            name: "name",
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid' : errors.name }]),
            id: "contact-name"
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_16, _toDisplayString(errors.name), 1)
        ])
      ]),
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_Field, {
            name: "street",
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid' : errors.street }]),
            id: "contact-street"
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_21, _toDisplayString(errors.street), 1)
        ])
      ]),
      _hoisted_22,
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_Field, {
            name: "city",
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid' : errors.city }]),
            id: "contact-city"
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_26, _toDisplayString(errors.city), 1)
        ])
      ]),
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _hoisted_29,
        _createElementVNode("div", _hoisted_30, [
          _createVNode(_component_Field, {
            name: "zip",
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid' : errors.zip }]),
            id: "contact-zip"
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_31, _toDisplayString(errors.zip), 1)
        ])
      ]),
      _hoisted_32,
      _createElementVNode("div", _hoisted_33, [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_Field, {
            value: _ctx.contact?.country || 'Česká republika',
            class: _normalizeClass([{ 'is-invalid' : errors.country }, "form-select"]),
            as: "select",
            name: "country",
            id: "contact-country"
          }, {
            default: _withCtx(() => [
              _hoisted_36
            ]),
            _: 2
          }, 1032, ["value", "class"]),
          _createElementVNode("div", _hoisted_37, _toDisplayString(errors.country), 1)
        ])
      ]),
      _hoisted_38,
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _createVNode(_component_Field, {
            name: "vatId",
            type: "text",
            class: _normalizeClass(["form-control", { 'is-invalid' : errors.vatId }]),
            id: "contact-vatId"
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_42, _toDisplayString(errors.vatId), 1)
        ])
      ]),
      _hoisted_43,
      _createElementVNode("div", _hoisted_44, [
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_Field, {
              name: "vatPayer",
              value: true,
              class: _normalizeClass(["form-check-input", { 'is-invalid' : errors.vatId }]),
              type: "checkbox",
              id: "contact-vatPayer"
            }, null, 8, ["class"]),
            _hoisted_48
          ])
        ])
      ]),
      _hoisted_49,
      _createElementVNode("div", _hoisted_50, [
        _createVNode(_component_SubmitButton, {
          "btn-title": _ctx.contact ? 'Uložit změny' : 'Vytvořit kontakt',
          loading: _ctx.loading,
          classes: "w-100 w-lg-auto mt-3 px-4 mt-lg-0"
        }, null, 8, ["btn-title", "loading"])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema", "initial-values"]))
}